<template>
    <main>

        <div class="login-body">

            <div class="login-background"></div>

            <router-link to="/">
                <img class="login-branding" src="/images/company-portal/logo.svg">
            </router-link>

            <div class="login-window">
                <div v-if="mode === 'reset'">
                    <h1 class="mb-6">Återställ ditt lösenord</h1>
                </div>

                <div v-if="mode === 'activate'">
                    <h1 class="mb-2">Aktivera ditt företagskonto</h1>
                    <p class="mb-8">Aktivera ditt företagskonto genom att välja ett lösenord nedan och spara. Välkommen!</p>
                </div>

                <form @submit.prevent="posterPost">
                    <input-text
                        type="password"
                        name="password"
                        label="Välj lösenord"
                        form-group-class="mb-4"
                        v-model="password"
                        :float-label="true"
                    />

                    <input-text
                        type="password"
                        name="password_confirmation"
                        label="Upprepa lösenord"
                        form-group-class="mb-4"
                        v-model="password_confirmation"
                        :float-label="true"
                    />

                    <div class="alert alert-danger" v-if="former.errors.email || former.errors.token">
                        <span v-if="former.errors.email">{{ former.errors.email[0] }}</span>
                        <span v-if="former.errors.token">{{ former.errors.token[0] }}</span>
                    </div>

                    <input type="submit" value="Spara och logga in" class="btn btn-primary float-end" :disabled="poster.submitted">
                </form>
            </div>
        </div>
    </main>
</template>

<script>

import poster from '../../../shared/mixins/poster'

export default {

    mixins: [
        poster
    ],

    data () {
        return {
            password: '',
            password_confirmation: '',
            mode: this.$route.meta.mode
        }
    },

    computed: {
        posterUrl () {
            return '/password/reset'
        },
        posterData () {
            return {
                password: this.password,
                password_confirmation: this.password_confirmation,
                email: this.$route.query.email,
                token: this.$route.query.token
            }
        }
    },

    methods: {
        posterSuccess () {
            window.location.href = '/'
        }
    }

}

</script>
